import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDsoNames } from '../../../actions/userActions';
import { UNASSIGNED_OPTION_VALUE } from '../../../constants/unassigned';
import { MultiSelectFilter } from './MultiSelectFilter';

/** DSO name filter. Writes the `dsoName` filter key. */
export const DsoNameFilter = ({ filter, handleFilterChange }) => {
  const dispatch = useDispatch();
  const dsoNames = useSelector((state) => state.users.dsoNames);

  useEffect(() => {
    if (!dsoNames) {
      dispatch(getDsoNames());
    }
  }, [dispatch, dsoNames]);

  const options = [
    { label: 'Unassigned', value: UNASSIGNED_OPTION_VALUE },
    ...(dsoNames || []).map((dso) => ({ label: dso.name, value: dso.code })),
  ];

  return (
    <MultiSelectFilter
      label="DSO Name"
      options={options}
      value={filter?.dsoName}
      onChange={(value) => handleFilterChange('dsoName', value)}
      optionsWidth={250}
    />
  );
};

export default DsoNameFilter;
